module.exports = __webpack_public_path__ + "img/Dass_Virkemiddelbruk.2709687a.jpg";